import type { GridRowId } from '@mui/x-data-grid-pro';
import type { DropNode, DropNodeId } from './rowReorderValidation';

export type DropPosition = 'above' | 'below' | 'inside';

export interface DropTarget {
  rowId: GridRowId;
  position: DropPosition;
  isCrossParent?: boolean;
}

export const calculateDropPosition = (clientY: number, rowRect: DOMRect): 'above' | 'below' => {
  const relativeY = clientY - rowRect.top;
  return relativeY < rowRect.height / 2 ? 'above' : 'below';
};

const TOP_EDGE_RATIO = 0.25;

export const isPointerAtTopEdge = (
  clientY: number,
  rowRect: Pick<DOMRect, 'top' | 'height'>,
): boolean => clientY - rowRect.top < rowRect.height * TOP_EDGE_RATIO;

export const isSameParent = (sourceNode: DropNode, targetNode: DropNode): boolean =>
  sourceNode.parent === targetNode.parent;

export const isNoOpDrop = (
  sourceRowId: DropNodeId,
  targetRowId: DropNodeId,
  position: DropPosition,
  prevSiblingId: DropNodeId | null,
  nextSiblingId: DropNodeId | null,
): boolean => {
  if (sourceRowId === targetRowId) return true;
  if (position === 'above' && targetRowId === nextSiblingId) return true;
  if (position === 'below' && targetRowId === prevSiblingId) return true;
  return false;
};
